export const environment = {
  production: true,
   serverUrl: 'https://netcorecalendar.bizmedica.ro'
  //serverUrl: 'https://localhost:44320'
};
